export default __webpack_public_path__ + "static/management_orange-eafa7b99155668d1b3e16eea4a21c438.svg";